import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage"; // ✅ Import Storage

const firebaseConfig = {
  apiKey: "AIzaSyBXv9RxU4mz5e2mPNb3pk5fSisQchDJchQ",
  authDomain: "marketbot-78b6d.firebaseapp.com",
  projectId: "marketbot-78b6d",
  storageBucket: "marketbot-78b6d.firebasestorage.app",
  messagingSenderId: "705558676342",
  appId: "1:705558676342:web:6311d34004568c634eb057"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app); // ✅ Initialize Storage

export { auth, db, storage }; // ✅ Export Storage
